import { Timestamp, getMaxWidthForWaveform } from '@mi-front/core';
import { graphPalette } from '@mi-front/ui';
import moment from 'moment-timezone';
import { DisplayableChunk } from '../../fragments/types';

export function getMaxWidthForStream(chunks: DisplayableChunk[]) {
  return chunks.reduce((total, current) => {
    const chunkDuration = moment(current.to).diff(current.from).valueOf();
    const segmentsDuration = current.segments.reduce((total, current) => {
      return total + current.duration;
    }, 0);
    const adjustment = chunkDuration / segmentsDuration;

    return total + getMaxWidthForWaveform(current.segments) * adjustment;
  }, 0);
}

export function convertSegmentsToRelative<
  T extends { startTs: number; endTs: number; duration: number },
>(relativeTs: Timestamp, segments: readonly T[]): readonly T[] {
  if (!segments.length) {
    return [];
  }

  const firstSegmentTs = segments[0].startTs;

  return segments.map((s) => {
    const startTs = relativeTs + (s.startTs - firstSegmentTs);
    const endTs = startTs + s.duration;

    return {
      ...s,
      startTs,
      endTs,
    };
  });
}

export function assignChunkColor(index: number) {
  return graphPalette[index % graphPalette.length];
}

export function assignChunkColors(chunks: DisplayableChunk[]): DisplayableChunk[] {
  let remaining = graphPalette.slice();

  return chunks.map((c) => {
    if (!remaining.length) {
      remaining = graphPalette.slice();
    }

    return {
      ...c,
      color: remaining.shift()!,
    };
  });
}
